var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-action',{staticClass:"mr-1"},[_c('v-btn',{attrs:{"icon":"","outlined":"","title":"Печать карты"},on:{"click":_vm.printMap}},[_c('v-icon',[_vm._v("mdi-printer")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }